export default "__VITE_ASSET__CVVgXBya__"